import { createSlice } from '@reduxjs/toolkit';

import { favouritesSummaryBuilder } from '../builders/favouritesSummary';
import type { FavouritesState } from '../types/favourites';

const initialState: Readonly<FavouritesState> = {
  summary: favouritesSummaryBuilder(),
  isModalOpen: false,
  selectedProductCodeForModal: null,
};

export const { actions, reducer } = createSlice({
  name: 'favourites',
  initialState,
  reducers: {
    setFavouritesSummary: (state, action) => {
      state.summary = action.payload;
    },
    closeModal: (state: FavouritesState) => {
      state.isModalOpen = false;
      state.selectedProductCodeForModal = null;
    },
    openModal: (state: FavouritesState, action) => {
      state.isModalOpen = true;
      state.selectedProductCodeForModal = action.payload;
    },
  },
});
